const CONFIG = {
  frontAddress: 'https://yousician.com/chords',
  frontRootAddress: 'https://yousician.com',
  yousicianApiAddress: 'https://api.yousician.com',
  gtSongsApiAddress: 'https://gtsongs-api-prod.yousician.com',
  gtSongsSearchApiAddress: 'https://gtsongs-api-prod.yousician.com',
  accountPageAddress: 'https://account.yousician.com',
  googleAdSensePublisherId: 'ca-pub-9783652625132852',
  guitartunaApiAddress: 'https://gtapi.yousician.com',
  adTest: false,
}

export default CONFIG

export const APPLICATION_NAME = 'GuitarTunaSongsSite'

export const PLANS_PAGE = 'https://account.yousician.com/guitartuna/plans'

export const HOME_APP_STORE = 'https://guitartuna.onelink.me/QVz5/hqn99qz0'
export const HOME_PLAY_STORE = 'https://guitartuna.onelink.me/QVz5/hqn99qz0'

export const SONG_APP_STORE = 'https://guitartuna.onelink.me/QVz5/aanm98rk'
export const SONG_PLAY_STORE = 'https://guitartuna.onelink.me/QVz5/aanm98rk'

export const GUITARTUNA = 'https://yousician.com/guitartuna'
export const SONGS_LIBRARY = 'https://yousician.com/songs'
export const CHORDS_LIBRARY = 'https://yousician.com/guitar-chords'

export const GUITAR = 'https://yousician.com/guitar'
export const PIANO = 'https://yousician.com/piano'
export const UKULELE = 'https://yousician.com/ukulele'
export const BASS = 'https://yousician.com/bass'
export const SINGING = 'https://yousician.com/singing'

export const GUITAR_TUNER = 'https://yousician.com/guitar-tuner'
export const VIOLIN_TUNER = 'https://yousician.com/violin-tuner'
export const UKULELE_TUNER = 'https://yousician.com/ukulele-tuner'
export const BASS_TUNER = 'https://yousician.com/bass-tuner'
export const MANDOLIN_TUNER = 'https://yousician.com/mandolin-tuner'
export const BANJO_TUNER = 'https://yousician.com/banjo-tuner'

export const COMPANY = 'https://yousician.com/company'
export const CAREERS = 'https://yousician.com/careers'
export const CONTACT = 'https://yousician.com/contact'
export const PRESS = 'https://yousician.com/press'
export const BLOG = 'https://yousician.com/blog'
export const HELP = 'https://yousician.zendesk.com'
export const TOS = 'https://yousician.com/terms-of-service'
export const PRIVACY_NOTICE = 'https://yousician.com/privacy-notice'
export const CCPA_NOTICE = 'https://yousician.com/ccpa-notice'
export const FAMILY_PLAN = 'https://yousician.com/family'
export const BUY_GIFT = 'https://account.yousician.com/gift'
export const REDEEM_GIFT = 'https://account.yousician.com/gift/redeem'

export const INSTAGRAM = 'https://www.instagram.com/yousician'
export const FACEBOOK = 'https://www.facebook.com/yousician'
export const TWITTER = 'https://twitter.com/yousician'
export const YOUTUBE = 'https://www.youtube.com/c/yousician'
export const LINKEDIN = 'https://www.linkedin.com/company/yousician'
